import React from 'react';
import PropTypes from 'prop-types';
import {SVGIcon} from '@homeaway/react-svg';

import './ReservationTrackerIcon.less';

export class ReservationTrackerIcon extends React.PureComponent {
    static propTypes = {
        icon: PropTypes.string,
        index: PropTypes.number,
        text: PropTypes.string,
        onADownloadClick: PropTypes.func,
    };

    render() {
        /* eslint-disable react/no-danger */
        return (
            <div className="reservation-tracker-icon">
                <div className="reservation-tracker-icon__container">
                    <div className="reservation-tracker-icon__svg-container text-center">
                        <SVGIcon markup={this.props.icon} />
                    </div>
                    <div className="reservation-tracker-icon__number-badge text-center">
                        {this.props.index}
                    </div>
                </div>
                <div
                    onClick={this.props.onADownloadClick}
                    dangerouslySetInnerHTML={{__html: this.props.text}}
                />
            </div>
        );
        /* eslint-enable react/no-danger */
    }
}
